import styles from './faq.module.scss';
import { useEffect, useState } from 'react';
import { faqContents } from './constants';
import { LinkArrow } from '../../../commons/hoc';
// MUI
import {
  Typography,
  Divider,
  Link,
  Stack,
  Box,
  Container,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Badge,
} from '@mui/material';
import MinusIcon from '../../../src/assets/images/icons/minus-icon.svg';
import PlusIcon from '../../../src/assets/images/icons/plus-icon.svg';
import PhoneIcon from '../../../src/assets/images/icons/phone.svg';
import { RF_ICON_SVG } from '../../../src/assets/images/global/index';
import { businessHourTiming } from '../../../commons/utils/utils';
import { config } from '../../../config';

const CustomExpandIcon = () => {
  return (
    <Box
      sx={{
        '.Mui-expanded & > .collapsIconWrapper': {
          display: 'none',
        },
        '.expandIconWrapper': {
          display: 'none',
        },
        '.Mui-expanded & > .expandIconWrapper': {
          display: 'block',
        },
      }}
    >
      <Typography className="expandIconWrapper">
        <MinusIcon className={styles.actionIcons} />
      </Typography>
      <Typography className="collapsIconWrapper">
        <PlusIcon className={styles.actionIcons} />
      </Typography>
    </Box>
  );
};

export const FaqAccordion = ({
  items,
  itemTitle,
  itemContent,
  gutterDisable = false,
}) => {
  const [expanded, setExpanded] = useState(0);
  const handleChange = (i) => {
    setExpanded(i);
  };
  return (
    <>
      {items.map((item, i) => (
        <>
          <Accordion
            expanded={expanded == i}
            key={i}
            className={styles['main-accordion']}
            onChange={() => handleChange(i)}
            disableGutters={gutterDisable}
          >
            <AccordionSummary
              expandIcon={<CustomExpandIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              className={styles['accordion-summary']}
            >
              <Typography variant="h4" color="primary.main">
                {item[itemTitle]}
              </Typography>
            </AccordionSummary>
            <AccordionDetails className={styles['accordion-details']}>
              <Box className={styles.accordionMainContent}>
                <Typography variant="p1">{item[itemContent]}</Typography>
              </Box>
            </AccordionDetails>
          </Accordion>
          {items.length - 1 != i && (
            <Divider className={styles['accordion-divider']} />
          )}
        </>
      ))}
    </>
  );
};

export default function Faq({ productType, id = '' }) {
  const [isOnline, setOnline] = useState(false);

  useEffect(() => {
    setOnline(
      businessHourTiming(
        config.supportHours.openTime,
        config.supportHours.closeTime
      )
    );
  }, []);

  return (
    <Box className={styles.faqBg} id={id}>
      <Container className={styles.faqContainer}>
        <Stack className={styles.faqHeadContent}>
          <Typography variant="h2" color="primary.main">
            You’ve Got Questions? We’ve Got Answers.
          </Typography>
        </Stack>
        <Stack className={styles.accordionSction}>
          <FaqAccordion
            items={faqContents[productType]}
            itemTitle={'title'}
            itemContent={'content'}
          />
        </Stack>
        <Stack className={styles.contactCard}>
          <Box className={styles.contactContent}>
            <Stack className={styles.contactContentInnerSection}>
              <RF_ICON_SVG />
              <Box className={styles.contactContentText}>
                <Typography variant="h4" className={styles.contactContentTab}>
                  Still Have Questions?
                </Typography>
                <div className={styles.contactContentMobile}>
                  <Typography variant="h4">Still Have Questions?</Typography>
                  <Typography variant="p1">
                    Contact us or give us a call if you still have questions.
                  </Typography>
                </div>
              </Box>
            </Stack>
          </Box>

          <Box
            justifyContent="center"
            sx={{ py: 2, textAlign: 'center' }}
            className={styles.contactSubContent}
          >
            <Typography variant="p1">
              Contact us or give us a call if you still have questions.
            </Typography>
          </Box>

          <Box className={styles.contactInfoSection}>
            <div className={styles.contactBtn}>
              <LinkArrow type="dark" href="/support">
                Contact Us
              </LinkArrow>
            </div>
            <hr className={styles.contactInfoDivider} />
            <Link href="tel:+1-833-888-1533" underline="none">
              <Stack className={styles.contactInfoContent}>
                <PhoneIcon />
                <Typography variant="h5" color="primary.main">
                  833-888-1533
                </Typography>
                <Badge
                  className={`${
                    isOnline ? styles.onlineStatus : styles.offlineStatus
                  }`}
                  sx={{
                    pr: 0.5,
                    color: 'warning',
                  }}
                  variant="dot"
                />
              </Stack>
            </Link>
          </Box>
        </Stack>
      </Container>
    </Box>
  );
}
